module.exports = __webpack_public_path__ + "media/markers/logimg_N-ae8cfcf4.png";